<div class="flex flex-col gap-4">
  @if (shouldShowMetadata()) {
    <div class="grid grid-cols-2 gap-4">
      <dojo-text-input [label]="'ID'" [readOnly]="true" [formCtrl]="formCtrl().controls.id" />
      <dojo-text-input [label]="'Solution paths count'" [readOnly]="true" [formCtrl]="solutionPathsCountFC()" />

      <dojo-text-input [label]="'Mark Code'" [formCtrl]="formCtrl().controls.mark_code" />
      <dojo-number-input [label]="'Marks number'" [formCtrl]="formCtrl().controls.marks" />
    </div>
    <dojo-topic-level-3-selector [label]="'Topic IDs'" [formCtrl]="formCtrl().controls.topic_ids" />
  }
  <div class="mb-2 flex flex-col gap-2">
    <dojo-content-item-editor
      [title]="MARKSCHEME_ITEM_TYPE_TO_LONG_LABEL[MarkschemeEditorItemEnum.MarkGroup] | titlecase"
      [contentItemsFormArray]="formCtrl().controls.criterion"
      [editingOptions]="editingOptions()"
      [allowTextEditingOverride]="editingOptions().allowMarkschemeEditing"
      [canAddRemoveImage]="editingOptions().allowMarkschemeStructureEditing ?? false"
      [canAddRemoveText]="editingOptions().allowMarkschemeStructureEditing ?? false"
      [canReorder]="editingOptions().allowMarkschemeStructureEditing ?? false"
      (editItem)="editMarkgroupItem($event)"
    />
  </div>

  <div class="flex flex-col gap-2">
    <div class="flex items-center gap-2">
      <span class="text-primary text-md font-semibold">Notes</span>
      @if (editingOptions().allowMarkschemeStructureEditing ?? false) {
        <dojo-button
          [fill]="'outline'"
          [customColor]="'sky'"
          (click)="addNote()"
          [disabled]="formCtrl().controls.notes.disabled"
          [size]="'xs'"
        >
          Add
        </dojo-button>
      }
    </div>

    @if (formCtrl().controls.notes.controls.length === 0) {
      <div class="text-md mt-1 rounded-lg border pb-3 pt-3 text-center text-neutral-300">No Notes Here</div>
    }

    <div
      class="text-primary 1pl-2 flex h-full flex-col gap-2"
      cdkDropList
      #notesDropList="cdkDropList"
      [cdkDropListData]="formCtrl().controls.notes"
      (cdkDropListDropped)="dropNote($event)"
      [cdkDropListOrientation]="'vertical'"
    >
      @for (noteControl of formCtrl().controls.notes.controls; track $index) {
        <div
          class="flex items-start gap-1 py-1"
          cdkDrag
          [cdkDragData]="noteControl"
          [cdkDragDisabled]="!(editingOptions().allowMarkschemeStructureEditing ?? false)"
        >
          @if (editingOptions().allowMarkschemeStructureEditing ?? false) {
            <dojo-icon-button
              [hidden]="$index === 0 && formCtrl().controls.notes.controls.length === 1"
              [icon]="'grip-vertical'"
              [iconSize]="14"
              cdkDragHandle
              class="cursor-move-button mt-2 self-start"
            />
          }
          <dojo-multi-line-text class="w-full" [formCtrl]="noteControl" />
          @if (editingOptions().allowMarkschemeStructureEditing ?? false) {
            <dojo-icon-button
              [matTooltip]="'Delete note'"
              [icon]="'trash-can'"
              (click)="removeNote($index)"
              [disabled]="formCtrl().controls.notes.disabled"
              class="mt-[5px] self-start"
            />
          }
        </div>
      }
    </div>
  </div>
</div>
